import { render, staticRenderFns } from "./SectionHead.vue?vue&type=template&id=24eca174&scoped=true"
import script from "./SectionHead.vue?vue&type=script&lang=js"
export * from "./SectionHead.vue?vue&type=script&lang=js"
import style0 from "./SectionHead.vue?vue&type=style&index=0&id=24eca174&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24eca174",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/crm1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24eca174')) {
      api.createRecord('24eca174', component.options)
    } else {
      api.reload('24eca174', component.options)
    }
    module.hot.accept("./SectionHead.vue?vue&type=template&id=24eca174&scoped=true", function () {
      api.rerender('24eca174', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pm/components/SectionHead.vue"
export default component.exports